import { AlertTitle, Typography } from "@mui/material";
import { Fragment } from "react";

export const MuiSnackbarContent = (props: {
  title: string;
  subtitle?: string;
}) => {
  return (
    <Fragment>
      <AlertTitle>{props.title}</AlertTitle>
      <Typography variant="body2">{props.subtitle}</Typography>
    </Fragment>
  );
};
